import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import styles from './PoweredByLogo.css';
import SITE_MODES from '../../../constants/site-modes';

const PoweredByLogo = ({ poweredBy, className, siteMode, src }) => (<div
    aria-hidden="true"
    className={className}
>
    {siteMode === SITE_MODES.EMPLOYER ? <div
        className={styles.powered}
    >
        Powered By:
    </div> : null}
    <img
        className={styles.logo}
        src={src || poweredBy}
        role="presentation"
        alt="Powered By"
    />
</div>);

PoweredByLogo.propTypes = {
    poweredBy: PropTypes.string,
    className: PropTypes.string,
    siteMode: PropTypes.number,
    src: PropTypes.string,
};

export default connect(({ theme }) => ({
    poweredBy: theme.poweredBy,
    siteMode: theme.siteMode,
}))(PoweredByLogo);



// WEBPACK FOOTER //
// ./src/client/Components/PoweredByLogo/PoweredByLogo.js